import { Component, OnInit, OnDestroy } from "@angular/core";
import { AppService } from "../../../../app.service";
import { Subscription } from "rxjs/Subscription";
import { PreferencesService } from "../../preferences.service";
import { NotificationsService } from "angular2-notifications";
import {
  PreferencesViewModel,
  LanguageViewModel,
  CurrencyViewModel,
  FormCategoryViewModel,
  PreferenceTaskListVM,
  GridColumn,
  UserGridColumnPreferenceUpdateDto,
  UserGridPreferenceUpdateDto
} from "../../models/preferences.model";
import { forkJoin } from "rxjs/observable/forkJoin";
import { TranslateService } from "../../../../translate";
import { UserService } from "../../../../../app/shared/services/user.service";
import { GenericIdName } from "../../../../../app/modules/GET_NEW_UI/setup-implement/setup-implement.model";
import { FavouriteDialogService } from "../../../../../app/modules/GET_NEW_UI/favourite-dialog/favourite-dialog.service";
import { MatDialog } from "@angular/material/dialog";
import { componentinspectionordercomponent } from "../../components/component-inspection-order/component-inspection-order.component";
import { Tuple } from "../../../../../app/entities";
import { CryptoService } from "../../../../services/crypto.service";
import {
  ManageEquipmentColumn,
  ScreenCode,
} from "../../../../../app/shared/enums/allEnums";

@Component({
  selector: "app-general-view",
  templateUrl: "./general-view.component.html",
  styleUrls: ["./general-view.component.scss"],
})
export class GeneralViewComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  p: PreferencesViewModel;
  loadingPreferences: boolean = true;
  currencies: CurrencyViewModel[];
  languages: LanguageViewModel[];
  languageWasChanged: boolean = false;
  getCurrentSelectedLang: number;
  dashboardDefaultView: number = 1;
  formCatList: GenericIdName[];
  private DashboardView = [
    { Id: 0, Name: "Fleet Overview" },
    { Id: 1, Name: "Component Overview" },
    { Id: 2, Name: "Wear Rate Overview" },
  ];

  ShowMaintenanceInsp: boolean = false;
  IncludeMaintenanceLastInspect: boolean = false;
  ShowEnableReplaceExistingTab: boolean = false
  dashboardTasksPreferneceView: number[] = []
  dashboardFleetPreferneceView: number[] = []
  dashboardPreferneceView: number[] = []
  compDashboardPreferneceView: number[] = [];
  screenCode = ScreenCode;
  DashboardPrefernceList: GridColumn[];
  ComponentDashboardPrefernceList: GridColumn[];
  UserGridColumnPreferenceUpdateDto: UserGridColumnPreferenceUpdateDto = new UserGridColumnPreferenceUpdateDto();
  constructor(
    private readonly _app: AppService,
    private readonly _pref: PreferencesService,
    private readonly _notify: NotificationsService,
    private _user: UserService,
    private _favouriteDialogService: FavouriteDialogService,
    private _dialog: MatDialog,
    private readonly _translate: TranslateService,
    private _crypto: CryptoService,
  ) {}

  ngOnInit() {
    this._app.setPageTitle("Preferences | General");
    this.loadAllData();
    this.LoadJobRoles();
    this.LoadAccesibleSystem();
    this.getReplaceExistingTabStatus();
    this.getTaskPreferenceForUser();
    this.getDashboardFleetPreferenceForUser();
    this.GetGridColumnsWithUserPreference(ScreenCode.ManageEquipment);
    this.GetGridColumnsWithUserPreference(ScreenCode.ComponentOverviewDashboard);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => {
      if (!s.closed) s.unsubscribe();
    });
  }
  isSafetyInspector: boolean = false;
  LoadJobRoles() {
    this._user.getUserJobRoles().subscribe((roles) => {
      roles.forEach((r) => {
        switch (r.Name) {
          case "Inspectors":
            this.isSafetyInspector = false;
            break;
          case "Interpreters":
            this.isSafetyInspector = false;
            break;
          case "Super User":
            this.isSafetyInspector = false;
            break;
          case "Administrator":
            this.isSafetyInspector = false;
            break;
          case "Customer Admin":
            this.isSafetyInspector = false;
            break;
          case "Safety Inspector":
            this.isSafetyInspector = true;
            break;
        }
      });
    });
  }

  hasUCSystemAcess: boolean = false;
  hasGETSystemAcess: boolean = false;
  hasSafetySystemAcess: boolean = false;

  AcessSystem: GenericIdName[];
  SystemId: number;
  LoadAccesibleSystem() {
    this._user.GetAllAcessibleSystem().subscribe((res) => {
      console.log(res);

      this.AcessSystem = res;
      this.SystemId = this.AcessSystem[0].Id;
      if (this.SystemId == 1) {
        this.hasUCSystemAcess = true;
        this.hasGETSystemAcess = false;
      } else if (this.SystemId == 2) {
        this.hasUCSystemAcess = false;
        this.hasGETSystemAcess = true;
      } else if (this.SystemId == 3) {
        this.hasUCSystemAcess = true;
        this.hasGETSystemAcess = true;
      }
    });

    this._user.GetSafetyEnabled().subscribe((res) => {
      if (res == true) {
        this.hasSafetySystemAcess = true;
      }
    });
  }

  loadAllData() {
    let generalPreferences = this._pref.getGeneralTabPreferences();
    let currencies = this._pref.getAllCurrencies();
    let languages = this._pref.getAllLanguages();
    let dashboardView = this._app.GetDashboardDefaultView();
    this.loadFormCatList();

    this._pref.getShowMaintenanceInsp().subscribe((res) => {
      if (res == "True") {
        this.ShowMaintenanceInsp = true;
      } else {
        this.ShowMaintenanceInsp = false;
      }
    });

    this._pref.getIncludeMaintenanceLastInspect().subscribe(res => {
      if (res == "True") {
        this.IncludeMaintenanceLastInspect = true;
      } else {
        this.IncludeMaintenanceLastInspect = false;
      }
    });

    this.subscriptions.push(forkJoin([currencies, languages, generalPreferences, dashboardView]).subscribe((results: any) => {
      // Currencies
      this.currencies = results[0];
      // Languages
      this.languages = results[1];
      // General Preferences Data
      this.p = results[2];
      this.getCurrentSelectedLang = this.p.LanguageId;
      // Dashboard Default View
      this.dashboardDefaultView = results[3];
      this.loadingPreferences = false;
    }, error => {
      console.error(error);
      this._notify.error('Error', 'Unable to load your preferences. Please contact TrackTreads support. ');
    }));
  }

  loadFormCatList() {
    this._favouriteDialogService.getFormCategoryList().subscribe((result) => {
      this.formCatList = result;
    });
  }

  updateHomePage(view: number) {
    this._app.SetDashboardDefaultView(view).subscribe((r: any) => {
      if (r.m_Item1) {
        this._notify.success("Saved", r.m_Item2);
      } else {
        this._notify.error(
          "Error",
          "Unable to change default view for Dashboard. Please contact TrackTreads support.",
        );
        console.log(r.m_Item2);
      }
    });
  }

  private getLanguageById(languageId: number): string {
    let l = this.languages.find((l) => languageId == l.Id);
    if (l == null) return "English";
    return l.Name;
  }

  updateLanguage(languageId: number) {
    this._pref.updateLanguage(languageId).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
          this.languageWasChanged = true;
          this._translate._sendPrefLang(this.getLanguageById(languageId));
        } else {
          this._notify.error(
            "Error",
            "Unable to update language. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update language. Please contact TrackTreads support. ",
        );
      },
    );
  }

  updateCurrency(currencyId: number) {
    this._pref.updateCurrency(currencyId).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
        } else {
          this._notify.error(
            "Error",
            "Unable to update currency. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update currency. Please contact TrackTreads support. ",
        );
      },
    );
  }

  UpdateDefaultCat(FormCatId: number) {
    this._pref.updateDefaultFormCategory(FormCatId).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
        } else {
          this._notify.error(
            "Error",
            "Unable to update default Form category. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update default Form category. Please contact TrackTreads support. ",
        );
      },
    );
  }

  UpdateUCSetupType(SetupTypeId: number) {
    this._pref.updateDefaultUCsetupType(SetupTypeId).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
          this.getDashboardFleetPreferenceForUser();
        } else {
          this._notify.error(
            "Error",
            "Unable to update default UC Setup Type. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update default UC Setup Type. Please contact TrackTreads support. ",
        );
      },
    );
  }

  UpdateEqCondition(Condition: number) {
    this._pref.updateEqCondition(Condition).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
          this.getDashboardFleetPreferenceForUser();
        } else {
          this._notify.error(
            "Error",
            "Unable to update default UC Equipment Conditions. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update default UC Equipment Conditions. Please contact TrackTreads support. ",
        );
      },
    );
  }

  UpdateEqConditionPage(Condition: number) {
    this._pref.UpdateEqConditionPage(Condition).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
        this.getDashboardFleetPreferenceForUser();
      } else {
        this._notify.error('Error', 'Unable to update UC Equipment Conditions Page. Please contact TrackTreads support. ');
        console.error(r.m_Item2);
      }
    }, error => {
      console.error(error);
      this._notify.error('Error', 'Unable to update UC Equipment Conditions Page. Please contact TrackTreads support. ');
    });
  }

  updateUom(uom: string) {
    this._pref.updateUom(uom).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
        } else {
          this._notify.error(
            "Error",
            "Unable to update unit of measurement. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update unit of measurement. Please contact TrackTreads support. ",
        );
      },
    );
  }

  updateUoD(uom: string) {
    this._pref.updateUod(uom).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
        } else {
          this._notify.error(
            "Error",
            "Unable to update unit of distance. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update unit of distance. Please contact TrackTreads support. ",
        );
      },
    );
  }
  updateFullName(name: string) {
    this._pref
      .updateFullName(encodeURIComponent(this._crypto.encrypt(name)))
      .subscribe(
        (r) => {
          if (r.m_Item1) {
            this._notify.success("Saved", r.m_Item2);
          } else {
            this._notify.error(
              "Error",
              "Unable to update full name. Please contact TrackTreads support. ",
            );
            console.error(r.m_Item2);
          }
        },
        (error) => {
          console.error(error);
          this._notify.error(
            "Error",
            "Unable to update full name. Please contact TrackTreads support. ",
          );
        },
      );
  }

  updatePhoneNumber(number: string) {
    this._pref
      .updatePhoneNumber(encodeURIComponent(this._crypto.encrypt(number)))
      .subscribe(
        (r) => {
          if (r.m_Item1) {
            this._notify.success("Saved", r.m_Item2);
          } else {
            this._notify.error(
              "Error",
              "Unable to update phone number. Please contact TrackTreads support. ",
            );
            console.error(r.m_Item2);
          }
        },
        (error) => {
          console.error(error);
          this._notify.error(
            "Error",
            "Unable to update phone number. Please contact TrackTreads support. ",
          );
        },
      );
  }

  updateStreetAddress(street: string) {
    this._pref
      .updateStreetAddress(encodeURIComponent(this._crypto.encrypt(street)))
      .subscribe(
        (r) => {
          if (r.m_Item1) {
            this._notify.success("Saved", r.m_Item2);
          } else {
            this._notify.error(
              "Error",
              "Unable to update street address. Please contact TrackTreads support. ",
            );
            console.error(r.m_Item2);
          }
        },
        (error) => {
          console.error(error);
          this._notify.error(
            "Error",
            "Unable to update street address. Please contact TrackTreads support. ",
          );
        },
      );
  }

  updateSuburb(suburb: string) {
    this._pref
      .updateSuburb(encodeURIComponent(this._crypto.encrypt(suburb)))
      .subscribe(
        (r) => {
          if (r.m_Item1) {
            this._notify.success("Saved", r.m_Item2);
          } else {
            this._notify.error(
              "Error",
              "Unable to update suburb. Please contact TrackTreads support. ",
            );
            console.error(r.m_Item2);
          }
        },
        (error) => {
          console.error(error);
          this._notify.error(
            "Error",
            "Unable to update suburb. Please contact TrackTreads support. ",
          );
        },
      );
  }

  updatePostCode(code: string) {
    this._pref
      .updatePostCode(encodeURIComponent(this._crypto.encrypt(code)))
      .subscribe(
        (r) => {
          if (r.m_Item1) {
            this._notify.success("Saved", r.m_Item2);
          } else {
            this._notify.error(
              "Error",
              "Unable to update post code. Please contact TrackTreads support. ",
            );
            console.error(r.m_Item2);
          }
        },
        (error) => {
          console.error(error);
          this._notify.error(
            "Error",
            "Unable to update post code. Please contact TrackTreads support. ",
          );
        },
      );
  }

  updateState(state: string) {
    this._pref
      .updateState(encodeURIComponent(this._crypto.encrypt(state)))
      .subscribe(
        (r) => {
          if (r.m_Item1) {
            this._notify.success("Saved", r.m_Item2);
          } else {
            this._notify.error(
              "Error",
              "Unable to update state. Please contact TrackTreads support. ",
            );
            console.error(r.m_Item2);
          }
        },
        (error) => {
          console.error(error);
          this._notify.error(
            "Error",
            "Unable to update state. Please contact TrackTreads support. ",
          );
        },
      );
  }

  updateCountry(country: string) {
    this._pref.updateCountry(country).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
        } else {
          this._notify.error(
            "Error",
            "Unable to update country. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update country. Please contact TrackTreads support. ",
        );
      },
    );
  }

  ChangeShowMaintenanceInsp(e) {
    var status = !this.ShowMaintenanceInsp;

    this._pref.updateShowMaintenanceInsp(status).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
        } else {
          this._notify.error(
            "Error",
            "Unable to update Show Maintenance Inspections. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update Show Maintenance Inspections. Please contact TrackTreads support. ",
        );
      },
    );
  }

  ChangeIncludeMaintenanceLastInspect(e) {
    var status = !this.IncludeMaintenanceLastInspect;

    this._pref.updateSIncludeMaintenanceLastInspect(status).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.error('Error', 'Unable to update Include Maintenance as Last Inspect flag. Please contact TrackTreads support. ');
        console.error(r.m_Item2);
      }
    }, error => {
      console.error(error);
      this._notify.error('Error', 'Unable to update Include Maintenance as Last Inspect flag. Please contact TrackTreads support. ');
    });
  }

  UpdateEnableReplaceExistingTab(e) {
    var status = !this.ShowEnableReplaceExistingTab;

    this._pref.UpdateEnableReplaceExistingTab(status).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", "Enable Replace Existing Tab");
          window.location.reload();
        } else {
          this._notify.error(
            "Error",
            "Unable to update. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update. Please contact TrackTreads support. ",
        );
      },
    );
  }

  getReplaceExistingTabStatus() {
    this._pref.GetReplaceExistingTabStatus().subscribe((res) => {
      if (res == "True") {
        this.ShowEnableReplaceExistingTab = true;
      } else {
        this.ShowEnableReplaceExistingTab = false;
      }
    });
  }

  prefernceList: PreferenceTaskListVM[];
  getTaskPreferenceForUser() {
    this._pref.getTaskPreferenceForUser().subscribe((res) => {
      this.prefernceList = res;
      this.dashboardTasksPreferneceView = res[0].TaskIDSelectedList;
    });
  }
  UpdateDefaultTaskPref() {
    console.log(this.dashboardTasksPreferneceView);
    this._pref
      .updatePreferenceforLoggedUser(this.dashboardTasksPreferneceView)
      .subscribe((r) => {
        if (r) {
          this._notify.success("Saved", r.m_Item2);
        } else {
          this._notify.error(
            "Error",
            "Unable to change GET Dashboard Tasks. Please contact TrackTreads support.",
          );
        }
        this.getTaskPreferenceForUser();
      });
  }

  DashboardFleetprefernceList: PreferenceTaskListVM[];
  getDashboardFleetPreferenceForUser() {
    this._pref.getDashboardFleetPreferenceForUser().subscribe((res) => {
      this.DashboardFleetprefernceList = res;
      this.dashboardFleetPreferneceView = res[0].TaskIDSelectedList;
      //this.loadAllData();
    });
  }
  UpdateDefaultDashboardFleetPref() {
    console.log(this.dashboardFleetPreferneceView);
    this._pref
      .updateDashboradFleetPreferenceforLoggedUser(
        this.dashboardFleetPreferneceView,
      )
      .subscribe((r) => {
        if (r) {
          this._notify.success("Saved", r.m_Item2);
        } else {
          this._notify.error(
            "Error",
            "Unable to change GET Dashboard Tasks. Please contact TrackTreads support.",
          );
        }
        this.getDashboardFleetPreferenceForUser();
      });
  }

  UpdateUCComponentInspectionOrderOption(UCCompInspectOrderOptionId: number) {
    this._pref
      .UpdateUCComponentInspectionOrderOption(UCCompInspectOrderOptionId)
      .subscribe(
        (r) => {
          if (r.m_Item1) {
            this._notify.success("Saved", r.m_Item2);
            if (UCCompInspectOrderOptionId == 2)
              this.openComponentInspectionOrderPopup(false);
            this.getDashboardFleetPreferenceForUser();
          } else {
            this._notify.error(
              "Error",
              "Unable to update UC Component Inspection Order. Please contact TrackTreads support. ",
            );
            console.error(r.m_Item2);
          }
        },
        (error) => {
          console.error(error);
          this._notify.error(
            "Error",
            "Unable to update UC Component Inspection Order. Please contact TrackTreads support. ",
          );
        },
      );
  }
  UpdateUCMultipleMeasurements(UCMultipleMeasurements: boolean) {
    this._pref.UpdateUCMultipleMeasurements(UCMultipleMeasurements).subscribe(
      (r) => {
        if (r.m_Item1) {
          this._notify.success("Saved", r.m_Item2);
          this.getDashboardFleetPreferenceForUser();
        } else {
          this._notify.error(
            "Error",
            "Unable to updateMultiple Measurements. Please contact TrackTreads support. ",
          );
          console.error(r.m_Item2);
        }
      },
      (error) => {
        console.error(error);
        this._notify.error(
          "Error",
          "Unable to update Multiple Measurements. Please contact TrackTreads support. ",
        );
      },
    );
  }

  UpdateUCForecastWornToday(UCShowWornPerToday: boolean) {
    this._pref.UpdateUCForecastWornToday(UCShowWornPerToday).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
        this.getDashboardFleetPreferenceForUser();
      } else {
        this._notify.error('Error', 'Unable to update UC Forecast % Worn. Please contact TrackTreads support. ');
        console.error(r.m_Item2);
      }
    }, error => {
      console.error(error);
      this._notify.error('Error', 'Unable to update UC Forecast % Worn. Please contact TrackTreads support. ');
    });
  }
  openComponentInspectionOrderPopup(showMeasurement: boolean) {
    const ComponentInspectionOrderPopupRef = this._dialog.open(
      componentinspectionordercomponent,
      {
        width: "400px",
        height: "700px",
        data: {
          showMeasurementCounts: showMeasurement,
        },
      },
    );
    ComponentInspectionOrderPopupRef.afterClosed().subscribe((details) => {
      if (details != null) {
        //this.recommmendationID = 1;
        this.getDashboardFleetPreferenceForUser();
      }
    });
  }
  GetGridColumnsWithUserPreference(screen: string) {
    this._pref.GetGridColumnsWithUserPreferenceAsync(screen).subscribe((res) => {
      if (screen == ScreenCode.ManageEquipment) {
        this.DashboardPrefernceList = res;
        this.dashboardPreferneceView = this.DashboardPrefernceList.filter(
          (c) => c.IsSelected,
        ).map((c) => c.GridId);
      } else {
        this.ComponentDashboardPrefernceList = res;
        this.compDashboardPreferneceView =
          this.ComponentDashboardPrefernceList.filter((c) => c.IsSelected).map(
            (c) => c.GridId,
          );
      }

      //this.loadAllData();
    });
  }
  savePreferences(screen:string) {
    console.log(this.dashboardPreferneceView);
    this.UserGridColumnPreferenceUpdateDto = new UserGridColumnPreferenceUpdateDto();
    const request = new UserGridPreferenceUpdateDto();
    request.ScreenCode = screen;
    request.GridIds =
        screen == this.screenCode.ManageEquipment
            ? this.dashboardPreferneceView
            : this.compDashboardPreferneceView;
    this._pref
      .UpdateGridColumnPreference(request)
      .subscribe((res) => {
        if (res) {
          this.GetGridColumnsWithUserPreference(screen);
          this._notify.success("Saved", "Preferences updated successfully.");
        }
      });
  }
}
